module.exports = __webpack_public_path__ + "static/media/infinity~32a569ce3c4623f336c656e2f1c9c7b00f775c41.50000e99.svg";